import React, { useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import { ToastContainer } from "react-toastify";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import _ from "lodash";

import authHeader from "../../../../services/auth-header";
import { API } from "../../../../backend";
import Helper from "../../../../Helper";
import { getTrans as t } from "../../../../Localization/translations";
import QuoteAdd from "./QuoteAdd";
import QuoteView from "./QuoteView";
import QuoteEdit from "./QuoteEdit";
import Quoteservice from "../../../../services/contract/Quotes/quotesServices";

function Quote({ id,customerPermission ,contract_number,contract_type}) {
  const tableRef = React.createRef();
  const [hideshow, setHideShow] = useState(false)
  const [quoteviewhide, setQuoteviewHide] = useState(false)
  const [quoteid, setQuoteID] = useState('')
  const [quotestatuscheck, setQuoteStatusCheck] = useState('')
  const [loading, setLoading] = useState(true);
  const [hideshowedit, setHideShowEdit] = useState(false)
  // const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  // const permissionsArray = permissionss.split(',');
  // var contractNumber = "";
  // var customerName = "";
  // const [state1, setState] = useState({
  //   isPaneOpen: false,
  //   isPaneOpenLeft: false,
  // });

  const hideshowstate = () => {
        setHideShow(true)
}

const handleEdit = (quote_id) => {
  setQuoteID(quote_id)
  setHideShowEdit(true)
}

  const handleView = (id) => {
    setQuoteID(id)
    setQuoteviewHide(true)
  };

  const checkstatus = () =>{
    Quoteservice.checkquotestatus(id).then((response)=>{
      setQuoteStatusCheck(response.data.response)
    })
  }

  useEffect(()=>{
    checkstatus()
  },[id])

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading === false ? (
        hideshow === true ? <QuoteAdd id={id} setShow={setHideShow} contract_number={contract_number} contract_type={contract_type}/>:

        quoteviewhide === true ?
        <QuoteView quote_id={quoteid} sethide={setQuoteviewHide}/>:

        hideshowedit === true ?
        <QuoteEdit id={quoteid} setshowhidedit={setHideShowEdit} contractid={id} contract_type={contract_type}/> :

        <div className="page-wrapper">
          <ToastContainer />
          <div className="content ">
            <div className="row show_contract show_invoice">
              <div className="ms-auto my-auto mt-lg-0 mt-4">
                <div className="">
                  <div className="row">
                   
                  </div>
                </div>
              </div>
              <div className="">
                <div className="col-md-12 ">
                  <div className="">
                    <div className="body">
                      <div className=" p-0">
                        <MaterialTable
                          tableRef={tableRef}
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          title={<h5 className="mb-0">{t("Payoff Quotes")}</h5>}
                          columns={[
                            {
                              title: `${t("Payoff Quote Number")}`,
                              field: "quote_number",
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                              render: (rowData) => (
                                <>
                                  {" "}
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payoff Quote Number")}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>

                                        handleView(
                                          rowData.id,
                                        )

                                    }
                                  >
                                    {rowData.quote_number}
                                  </div>
                                </>
                              ),
                            },
                            
                           
                            {
                              title: `${t("Termination Type")}`,
                              field: "termination_type",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Termination Type")}
                                  </div>
                                  <div>{rowData.termination_type}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                                {
                                    title: `${t("Termination Date")}`,
                              field: "termination_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Termination Date")}
                                  </div>
                                  <div>
                                    {rowData.termination_date
                                      ? Helper.DateNormal(
                                        rowData.termination_date
                                        )
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                },
                            },
                            {
                            title: `${t("Payoff Quote Status")}`,
                            field: "quote_status",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Payoff Quote Status")}
                                </div>
                                <div>
                                  {rowData.quote_status
                                    ? 
                                      rowData.quote_status
                                    
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                            {
                            title: `${t("Expiry Date")}`,
                            field: "expiry_date",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Expiry Date")}
                                </div>
                                <div>
                                  {rowData.expiry_date
                                    ? Helper.DateNormal(
                                      rowData.expiry_date
                                    )
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                           
                           
                          ]}
                          data={(query) =>
                            new Promise((resolve, reject) => {
                              let url = API + "contracts/quoteview/?";
                              url += "per_page=" + query.pageSize;
                              url += "&page=" + (query.page + 1);
                              url += "&search=" + query.search;
                              url += "&contract_id=" + id;
                              fetch(url, { headers: authHeader() })
                                .then((response) => response.json())
                                .then((result) => {
                                  resolve({
                                    data:
                                      query.orderBy && query.orderDirection
                                        ? _.orderBy(
                                          result.data,
                                          [query.orderBy.field],
                                          [query.orderDirection]
                                        )
                                        : result.data,
                                    page: result.page - 1,
                                    totalCount: result.total,
                                  });
                                });
                            })
                          }
                          localization={{
                            toolbar: {
                              searchPlaceholder: "Search Contracts",
                            },
                          }}
                          actions={[

                            (rowData) =>({ 

                              icon: () => rowData.quote_status ==="Draft"? <img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit" />:
                               <img src={process.env.PUBLIC_URL + '/static/images/grey-ic-edit.svg'} alt="Edit" />,
                              tooltip: "Edit",
                              // disabled: (rowData) => rowData.quote_status !== "Draft" ? false : true,
                              onClick: (event, rowData) => {
                                if(rowData.quote_status ==="Draft"){

                                  handleEdit(rowData.id)
                                }
                                else{
                                }
                              },
                              disabled :rowData.quote_status !== "Draft" ,
                            }),
                            // {
                            //   icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit" />,
                            //   tooltip: "Edit",
                            //   // disabled: (rowData) => rowData.quote_status !== "Draft" ? false : true,
                            //   onClick: (event, rowData) => {
                            //     if(rowData.quote_status ==="Draft"){

                            //       handleEdit(rowData.id)
                            //     }
                            //     else{
                            //     }
                            //   },
                            //   disabled :(rowData)=>rowData.quote_status !== "Draft" ,
                            // },
                          ]}
                          components={{
                            Toolbar: (props) => (
                              <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                                <MTableToolbar {...props} />
                                      {
                                        customerPermission !== 'Customer' &&
                                        quotestatuscheck > 0 ?
                                        "": 
                                        <button
                                          className="add btn btn-primary mb-0 btn-sm dropdown-toggle"
                                          onClick={hideshowstate}
                                          type="button"
                                          id="add-task"
                                        >
                                    +&nbsp; {t("Add Quote")}
                                        </button> 
                                      }
                                  </div>
                            ),
                          }}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 11,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            toolbar: true,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 20, 25, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            exportAllData: true,
                            exportButton: false,
                            exportFileName: "Contracts",
                            exportPdf: (data, columns) => {
                              const doc = new jsPDF();
                              const columnTitles = data.map(
                                (columnDef) => columnDef.title
                              );
                              const pdfData = columns.map((rowData) =>
                                data.map(
                                  (columnDef) => rowData[columnDef.field]
                                )
                              );
                              // doc.autoTable({
                              autoTable(doc,{
                                head: [columnTitles],
                                body: pdfData,
                              });

                              doc.save(`contract.pdf`);
                            },
                            actionsColumnIndex: -1,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default Quote;
